import * as React from 'react';
export const CrossSiteRedirect = ({ to, }) => {
    React.useEffect(() => {
        if (to == '/')
            window.location.assign('/');
        else
            window.location.href = to;
    }, []);
    return React.createElement(React.Fragment, null);
};
export default CrossSiteRedirect;
